import NAME from "./constants";

export const getGridResultDialogIsLoading = store => store[NAME].loading;
export const getIsOpen = store => store[NAME].gridIsOpen;
export const getData = store => store[NAME].gridData;